import { Injector } from '@angular/core';
import { LanguageService } from '../services/language/language.service';

export class Multilingual {

    public languageService: LanguageService;
    public translations: any = {};
    public ui: any = {};

    constructor(injector: Injector) {
        this.languageService = injector.get(LanguageService);
        this.languageService.language.subscribe((language: string) => {
            this.loadText(language);
        });
    }

    public loadText(language: string) {
        this.ui = this.translations[language];
    }

    public setTranslations(translations: any) {
        this.translations = translations;
        this.loadText(this.languageService._language.value);
    }

}